import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { RatioItemEdit } from "./ratio-item.edit";
import { emptyRatio, IRatioItemFormProps } from "./table-ratios.models";

export const RatioItemAdd: FC<IRatioItemFormProps> = ({
  index,
  setValue,
  getValues,
  fieldName,
  onEditStart,
  onEditEnd,
}) => {
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isAddNewOpened) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [isAddNewOpened, onEditStart, onEditEnd]);

  return (
    <>
      {isAddNewOpened && (
        <RatioItemEdit
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          value={emptyRatio}
          index={index}
          onCancel={() => {
            setAddNewOpenedState(false);
          }}
        />
      )}
      {!isAddNewOpened && (
        <div className="add_item_button_wrapper">
          <Button type="button" onClick={() => setAddNewOpenedState(true)}>
            {t("general.APPEND")}
          </Button>
        </div>
      )}
    </>
  );
};
